import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, take, tap } from 'rxjs';
import { Service } from '../models/service.model';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ServicesService } from '../providers/api/services.service';

@Injectable({ providedIn: 'root' })
export class ServiceService {

  public services$: ReplaySubject<Service[]> = new ReplaySubject<Service[]>(0);
  public servicesObject$: ReplaySubject<{ [id: string]: Service }> = new ReplaySubject<{ [id: string]: Service }>(0);

  public services: Service[] = [];
  public servicesObject: { [id: string]: Service } = {};


  constructor(
    private firestore$: AngularFirestore,
    private serviceApi$: ServicesService
  ) {
  }

  getAll(): Observable<Service[]> {
    // return this.firestore$.collection<Service>('services').valueChanges({ idField: 'id' })
    //   .pipe(
    return this.serviceApi$.servicesControllerFindAll()
      .pipe(
        tap((services) => {
          const obServices = {};
          services.forEach(fe => {
            obServices[fe.id] = fe;
          });
          this.servicesObject = obServices;
          this.services = services;

          this.servicesObject$.next(obServices);
          this.services$.next(services);
        }),
        take(1)
      );
  }
}
